import { Link, useLocation } from "react-router-dom";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面走丢了 | 513吃瓜",
    description: "这个页面可能已经被合并或下线了，回到 513吃瓜首页或热梗库继续冲浪吧。",
    keywords: "513吃瓜,页面未找到",
    path: "/404",
  });

  return (
    <div className="mx-auto flex w-full flex-col items-center px-4 py-32 text-center md:px-6 md:py-40">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-3xl text-primary-600">
        <i className="ri-emotion-laugh-line" aria-hidden="true"></i>
      </span>
      <h1 className="mt-6 text-3xl leading-tight text-foreground-950 md:text-5xl">这个瓜，我们没找到</h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
        页面可能已经被合并或下线了，也可能链接输错了一点点。
        <span className="mt-1 block font-label text-xs text-foreground-400">{location.pathname}</span>
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-base" aria-hidden="true"></i>
          回到首页
        </Link>
        <Link
          to="/topics"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          去热梗库逛逛
        </Link>
      </div>
    </div>
  );
}